module.exports = __webpack_public_path__ + "static/media/service-provider.37a17356.svg";